module.exports = __webpack_public_path__ + "images/profile-recordlabel.png?3a13d";